import { BET_CONFIG } from 'src/config'
import type { MarbleGame } from 'src/types/domain/Game'

export const getBettingTimeWindow = (game: MarbleGame): number => {
  const bettingOpenWindow = game.bettingOpenWindow ? game.bettingOpenWindow : BET_CONFIG.DEFAULT_BETTING_OPEN_WINDOW_SEC
  const bettingClosingWindow = game.bettingClosingWindow ? game.bettingClosingWindow : BET_CONFIG.DEFAULT_BETTING_CLOSING_WINDOW_SEC

  return bettingOpenWindow + bettingClosingWindow
}
